import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import { getMortgageRates } from '../LegalDisclosuresModal/constans.js';
import { STATE_NAMES } from './constants.js';
import MortgageRateTrends from './MortgageRateTrends.js';

var MortgageRatesTrendsBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs,
      _ref$blockData = _ref.blockData,
      blockData = _ref$blockData === void 0 ? {} : _ref$blockData;
    var _attrs$loanPurpose = attrs.loanPurpose,
      loanPurpose = _attrs$loanPurpose === void 0 ? 'Purchase' : _attrs$loanPurpose,
      _attrs$creditRating = attrs.creditRating,
      creditRating = _attrs$creditRating === void 0 ? '740 or higher' : _attrs$creditRating,
      _attrs$location = attrs.location,
      location = _attrs$location === void 0 ? 'United States' : _attrs$location,
      _attrs$percentDown = attrs.percentDown,
      percentDown = _attrs$percentDown === void 0 ? '20% or higher' : _attrs$percentDown,
      _attrs$timeSpan = attrs.timeSpan,
      timeSpan = _attrs$timeSpan === void 0 ? '365' : _attrs$timeSpan;
    var defaultValues = {
      loanPurpose: loanPurpose,
      creditRating: creditRating,
      location: location,
      percentDown: percentDown,
      timeSpan: timeSpan
    };
    var editorMode = isEditor();
    return /*#__PURE__*/React.createElement(MortgageRateTrends, {
      defaultValues: defaultValues,
      editorMode: editorMode,
      blockData: blockData
    });
  },
  metadata: {
    $schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'constellation/mortgageratetrends',
    title: 'Mortgage Rate Trends',
    description: 'Interactive graph to see historical mortgage rates tailored by loan program, credit score, down payment and location.',
    icon: 'chart-line',
    keywords: ['Mortgage', 'trends'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'more',
    attributes: {
      loanPurpose: {
        type: 'string',
        default: 'Purchase',
        label: 'Default loan purpose',
        control: 'select',
        choices: [{
          label: 'Purchase',
          value: 'Purchase'
        }, {
          label: 'Refinance',
          value: 'Refinance'
        }]
      },
      creditRating: {
        type: 'string',
        default: '740 or higher',
        label: 'Default credit rating',
        control: 'select',
        choices: [{
          label: '740 or higher',
          value: '740 or higher'
        }, {
          label: '680 - 740',
          value: '680 - 740'
        }, {
          label: 'Less than 680',
          value: 'Less than 680'
        }]
      },
      location: {
        type: 'string',
        label: 'Default location',
        default: 'United States',
        control: 'select',
        choices: STATE_NAMES.map(function (label) {
          return {
            label: label,
            value: label
          };
        })
      },
      percentDown: {
        type: 'string',
        default: '20% or higher',
        label: 'Default percent down',
        control: 'select',
        choices: [{
          label: '20% or higher',
          value: '20% or higher'
        }, {
          label: '5% - 20%',
          value: '5% - 20%'
        }, {
          label: 'Less than 5%',
          value: 'Less than 5%'
        }]
      },
      timeSpan: {
        type: 'number',
        default: 365,
        label: 'Default timespan',
        control: 'select',
        choices: [{
          label: '1 day',
          value: 1
        }, {
          label: '7 days',
          value: 7
        }, {
          label: '1 month',
          value: 30
        }, {
          label: '3 months',
          value: 90
        }, {
          label: '1 year',
          value: 365
        }, {
          label: '2 years',
          value: 730
        }]
      }
    }
  },
  getBlockData: function getBlockData(_ref2) {
    return new Promise(function ($return, $error) {
      var attrs, _attrs$pathname, pathname, data;
      attrs = _ref2.attrs;
      _attrs$pathname = attrs.pathname, pathname = _attrs$pathname === void 0 ? '/mortgage-rates/' : _attrs$pathname;
      return Promise.resolve(getMortgageRates(pathname)).then(function ($await_1) {
        try {
          data = $await_1;
          return $return(data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
};
var MortgageRatesTrendsBlock$1 = MortgageRatesTrendsBlock;

export { MortgageRatesTrendsBlock$1 as default };
